import React from "react";
import swinkpay_logo from "../assets/swinklogo.png";

/**
 * SwinkPay branded gradient-arc spinner with logo + shimmer sweep.
 * @param {number} size - outer diameter in px (default 92)
 */
const SwinkSpinner = ({ size = 92 }) => {
  const inset1 = Math.round(size * 0.076); // subtle inner ring inset
  const inset2 = Math.round(size * 0.12);  // white disc inset
  const logoSize = Math.round(size * 0.46);
  const strokeW = Math.round(size * 0.054);
  const dash1 = Math.round(size * 1.25);
  const dash2 = Math.round(size * 1.685);

  return (
    <div style={{ position: "relative", width: size, height: size }}>
      {/* Spinning gradient arc — blue → green */}
      <svg
        className="animate-spin"
        style={{ position: "absolute", inset: 0, width: size, height: size, animationDuration: "2.4s" }}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
      >
        <defs>
          <linearGradient id="swinkArcGrad" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={size} y2={size}>
            <stop offset="0%" stopColor="#1E56C8" />
            <stop offset="55%" stopColor="#24CB7E" />
            <stop offset="100%" stopColor="rgba(30,86,200,0)" />
          </linearGradient>
        </defs>
        {/* Track */}
        <circle cx={size / 2} cy={size / 2} r={size / 2 - strokeW} stroke="rgba(30,86,200,0.08)" strokeWidth={strokeW} />
        {/* Moving arc */}
        <circle
          cx={size / 2} cy={size / 2} r={size / 2 - strokeW}
          stroke="url(#swinkArcGrad)" strokeWidth={strokeW}
          strokeLinecap="round" strokeDasharray={`${dash1} ${dash2}`}
        />
      </svg>

      {/* Subtle inner ring */}
      <div style={{ position: "absolute", inset: inset1, borderRadius: "50%", border: "1px solid rgba(30,86,200,0.1)" }} />

      {/* White disc with logo + shimmer */}
      <div style={{
        position: "absolute", inset: inset2, borderRadius: "50%",
        background: "white",
        boxShadow: "0 4px 20px rgba(30,86,200,0.18), 0 1px 4px rgba(0,0,0,0.06)",
        display: "flex", alignItems: "center", justifyContent: "center",
        overflow: "hidden",
      }}>
        <img src={swinkpay_logo} alt="SwinkPay" style={{ width: logoSize, height: logoSize, objectFit: "contain" }} />
        {/* Continuous shimmer sweep */}
        <div style={{
          position: "absolute", top: "-30%", bottom: "-30%", width: "45%",
          background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.82) 50%, rgba(255,255,255,0) 100%)",
          animation: "shimmer-sweep 2.2s ease-in-out infinite",
          pointerEvents: "none",
        }} />
      </div>
    </div>
  );
};

export default SwinkSpinner;
